module.exports = __webpack_public_path__ + "static/media/esti_square.c4b0fa2b.png";